module.exports = __webpack_public_path__ + "img/source_book-bt-more.631b0af1.png";